// Default Layout styles (required for <media-video-layout />)
import "vidstack/player/styles/default/theme.css";
import "vidstack/player/styles/default/layouts/video.css";

// Registers all <media-*> custom elements globally
import "vidstack/player";
import "vidstack/player/layouts/default";
import "vidstack/player/ui";

export default defineNuxtPlugin((_nuxtApp) => {});
